const PageBlobs = () => (
  <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-0">
    {[
      { top: "14%", right: "3%", size: 150, cls: "bg-[#DCFCE7]/70" },
      { top: "34%", left: "1.5%", size: 110, cls: "bg-[#22C55E]/10" },
      { top: "52%", right: "5%", size: 190, cls: "bg-[#DCFCE7]/60" },
      { top: "68%", left: "3%", size: 130, cls: "bg-[#FACC15]/20" },
      { top: "86%", right: "2%", size: 170, cls: "bg-[#DCFCE7]/70" },
    ].map((b, i) => (
      <div
        key={i}
        className={`absolute rounded-full blur-3xl ${b.cls}`}
        style={{
          top: b.top,
          right: b.right,
          left: b.left,
          width: b.size,
          height: b.size,
        }}
      />
    ))}
  </div>
);

export default PageBlobs;
